import { i18n } from "@lingui/core";
import { detect, fromHtmlTag } from "@lingui/detect-locale";
import { I18nProvider } from "@lingui/react";
import type * as React from "react";

// @ts-expect-error: build time
import { messages as enMessages } from "locale/en.po";
// @ts-expect-error: build time
import { messages as frMessages } from "locale/fr.po";

export function loadI18n() {
  i18n.load({
    en: enMessages,
    fr: frMessages,
  });
}

export function getLocaleProvider() {
  loadI18n();
  i18n.activate(detect(fromHtmlTag("lang")) ?? "en");

  return ({
    children,
  }: {
    children: React.ReactNode;
  }) => <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
